<template >
  

<div class="tab-inner-content">
    <div class="tabs-content-panel tab-pad-wrap">
      <div class="card-panels">
        
        <vs-row vs-justify="center" >


        <vs-col class="p-0" type="flex" vs-justify="center" vs-align="center" vs-w="12">
            <div class="forms_letters">
              <vs-tabs>
                <vs-tab label="Documents"  >
                    <div class="main-list-wrap pad0">
                    <div  class="tab-inner-content">
                      <div class="doc_header pt-0 d" v-if="checkProperty( petition,'permDocs' ,'length')>0" >
                        <h3 class="small-header mart25"  >
                          <template >
                               Documents
                          </template>
                        </h3>
                            <div class="d-flex" v-if="false">   

                            <button   class="download_all">Download Documents</button>
                            </div>
                      </div>
                                                
                                              
                    <template   >
                        <div >
                        <vs-row  >
                            <vs-col class="padl0 padr0" v-if="checkProperty( petition,'permDocs' ,'length')>0">
                              <div class="card-panels pad0">
                                <vs-card>
                                <div slot="header" >
                                  <h3>PERM Documents</h3> 
                                  
                                </div>
                                <div>
                                  <div>
                                     <template v-for="(item ,ind ) in  petition['permDocs']" >
                                  
                                      <div class="documents__list" v-if="checkProperty( item,'status') !=false" v-bind:key="ind">
                                        <div class="documents__title" @click="downloadfile(item)">
                                          <figure> 
                                            <img v-if="checkFileFormat(item['mimetype']) =='pdf'" src="@/assets/images/main/pdf.svg" /> 
                                            <img v-else-if="checkFileFormat(item['mimetype']) =='video_mime_types'" src="@/assets/images/main/film.png" />
                                            <img v-else-if="checkFileFormat(item['mimetype']) =='msDoc'" src="@/assets/images/main/doc.svg" />
                                            <img v-else-if="checkFileFormat(item['mimetype']) =='zip'" src="@/assets/images/main/zip-file-format.png" />
                                            <img v-else-if="checkFileFormat(item['mimetype']) =='msPpt'" src="@/assets/images/main/ppt.svg" />
                                            <img v-else-if="checkFileFormat(item['mimetype']) =='msXl'" src="@/assets/images/main/xls.svg" />
                                            <img v-else-if="checkFileFormat(item['mimetype']) =='image'" src="@/assets/images/main/image.svg" />
                                            <img v-else src="@/assets/images/main/icon-img.svg" />
                                          </figure>
                                          <span>{{item.name}}</span>
                                        </div>
                                        <div class="documents__actions">
                                          <button @click="downloadfile(item)" class="view-btn">View</button>
                                        </div>
                                      </div>
                                    </template>
                                  </div>
                                </div>
                                </vs-card>
                              </div>
                            </vs-col>
                           <!------Edit Section && !checkProperty(petition ,'permId')-->
                            <vs-col class="padl0 padr0" v-if="editJobDetails">
                              <div class="card-panels pad0 perm_job_details">
                                <vs-card>
                                <div slot="header" >
                                  <h3>Job Details</h3> 
                                  
                                </div>
                                  <div class="vx-col  w-full form_section pl-0 pr-0 padt20"  >
                                    <form data-vv-scope="permJobDetailsform" @submit.prevent="" @keydown.enter.prevent="">
                                      <div class="form-container alt-rows-bg" @keyup="formerrorsMsg=''">
                                         

                                          <span class="inline_note mt-0 mb-2">NOTE: Please make sure to upload only Certified PERM only.</span>
                                          <div class="vx-col w-full" @click="permDocuments = []">
                                              <div class="form_group file_group">
                                                <div class="vs-component marb20">
                                                <label class="form_label">PERM Documents<em>*</em>
                                                  <!-- <div class="IB_tooltip"  >
                                                    <span><info-icon size="1.5x" class="custom-class"></info-icon></span>
                                                     <div class="tooltip_cnt"> <p>  Please make sure to upload only Certified PERM only. </p></div>
                                                   </div> -->
                                                   <!-- <p><span>Note:</span> </p> -->
                                                </label>
                                                
                                                  <div class="relative">
                                                    
                                                <file-upload
                                                    v-model="permDocuments"
                                                    class="file-upload-input upload_file justify-center"
                                                    :accept="pdfDocEntity"
                                                    :name="'documents'"
                                                    :multiple="false"
                                                    @updateData="updateData"
                                                    :emitCategory="'permDocuments'"
                                                    :hideSelected="true"
                                                    
                                                  >
                                                  <!-- @input="uploadPermDocs(permDocuments , 'permDocuments')" -->
                                                    <img
                                                      class="file-icon"
                                                      src="@/assets/images/main/file-upload.svg"
                                                    />
                                                    Upload 
                                                  </file-upload>
                                                  <span  v-if="uploading" class="loader"   ><img src="@/assets/images/main/loader.gif"   /></span>
                                                  </div>
                                                  <!---
                                                   
                                                  <input type="hidden" v-model="newTask.documents"  data-vv-as="Documents"  v-validate="'required'" name="tdocs">
                                                  <span  class="text-danger text-sm" v-show="errors.has('tdocs')"   >{{ errors.first('tdocs') }}</span >
                                                  -->
                                                  <input type="hidden" :name="'permDocuments'" v-validate="'required'"  data-vv-as="PERM Documents"  v-model="permDolDocs">
                                                  <span v-if="permDocFormatError" class="text-danger text-sm" >{{permDocFormatError}}</span>
                                                  <span v-else class="text-danger text-sm" v-show="errors.has('permJobDetailsform.permDocuments')">*PERM Documents are required</span>
                                              
                                                </div>
                                              

                                                <ul class="uploaded-list ">
                                                  <template v-for="(item, index) in permDolDocs">
                                                    <vs-chip
                                                    @click="skillTextError=false;setJobDetailsData();permDocPreFilledKyes=[];draftExtractInfo=null;remove(item, permDolDocs, index)"
                                                      :key="index"
                                                      closable
                                                    >
                                                    {{ item.name }}
                                                    </vs-chip>
                                                  </template>
                                                </ul>
                                              </div>
                                          </div>

                                          <div class="vx-row">
                                            <immiInput :disabled="permDocPreFilledKyes.indexOf('jobTitle')>-1" :display="true" :wrapclass="'vx-col md:w-1/2'" :required="true" :fieldsArray="questionnaireDetails" cid="permjobTitle" formscope="permJobDetailsform" v-model="jobDetails['jobTitle']"  fieldName="jobTitle" label="Job Title" placeHolder="Job Title" :maxLength="25" />
                                            <immiInput :disabled="permDocPreFilledKyes.indexOf('hoursPerWeek')>-1" :onlyNumbers="true" :wrapclass="'vx-col md:w-1/2'" :display="true" cid="permhoursPerWeek" :formscope="'permJobDetailsform'"  v-model="jobDetails.hoursPerWeek" :required="true" fieldName="hoursPerWeek" label="Hours per Week" placeHolder="Hours per Week"  :maxLength="3" />
                                            <immiInput :disabled="permDocPreFilledKyes.indexOf('wageRate')>-1" :onlyNumbers="true" :wrapclass="'vx-col md:w-1/2'" :display="true" cid="permwageRate" :formscope="'permJobDetailsform'" v-model="jobDetails.wageRate" :required="true" fieldName="wageRate" label=" Wage Rate" placeHolder="Wage Rate" :maxLength="10" />
                                            <selectField :disabled="permDocPreFilledKyes.indexOf('payFrequency')>-1" :listContainsId="false" :wrapclass="'vx-col md:w-1/2'" :display="true" :required="true"  :formscope="'permJobDetailsform'" cid="permofferpayFrequency"  :optionslist="payFrequencyList" v-model="jobDetails.payFrequency"  fieldName="offerpayFrequency" label="Pay Frequency" placeHolder="Pay Frequency"   />  
                                            <selectField  :isDisabled="permDocPreFilledKyes.indexOf('socCode')>-1" :showOptionItemStatus="true" :wrapclass="'md:w-1/2'" :required="[50].indexOf(getUserRoleId)>-1?false:true"  cid="socCode"  :formscope="'permJobDetailsform'" :optionslist="masterSocList" v-model="jobDetails.socDetails" @input="updatesocCode"   fieldName="socCod" label="SOC Code" placeHolder="SOC Code "   />  
                                            <!-- <datepickerField :isDisabled="permDocPreFilledKyes.indexOf('i140PriorityDate') > -1"wrapclass="md:w-1/2"  cid="i140PriorityDate"
                                            :display="true" v-model="jobDetails.i140PriorityDate" :formscope="'permJobDetailsform'" fieldName="i140PriorityDate" label="Priority Date of I-140" :validationRequired="true" /> -->
                                            <immiswitchyesno :display="true" :wrapclass="'vx-col md:w-full'" :fieldsArray="[]"
                                            :cid="'isExpRequired'" formscope="permJobDetailsform" v-model="jobDetails.isExpRequired"
                                            fieldName="isExpRequired" label="Is experience in the job offered required for the job? " placeHolder="" />

                                            <immiInput v-if="checkProperty(jobDetails, 'isExpRequired')"
                                            :disabled="permDocPreFilledKyes.indexOf('noOfExpMonths') > -1" 
                                            :onlyNumbers="true"  :wrapclass="'md:w-1/2 custom_form_group'"
                                            :display="true" cid="noOfExpMonths" :formscope="'permJobDetailsform'" v-model="jobDetails.noOfExpMonths"
                                            :required="true" fieldName="noOfExpMonths" label="No of months of experience" placeHolder="No of months of experience"
                                            :maxLength="5" />
                                            <template >
                                            <div class="vx-col w-full mt-2">
                                            <div class="skilladdsec">
                                            <label>Skills Required</label>
                                            <ul v-if="checkProperty(jobDetails ,'skills' ,'length' )>0">
                                                <li v-for="(skil , index ) in jobDetails['skills']" :key="index">
                                                    <span class="skill-label">{{skil}}</span>                                  
                                                    <span  @click="removePermSkill(index)" class="row_btn">
                                                        <img src="@/assets/images/main/delete-row-img.svg">
                                                    </span>
                                                </li>
                                            </ul>
                                            <div class="add-input-sec" >
                                                
                                                <div  @keyup="addSkill=true;skillTextError=false" class="skill-text" :class="{'skill-text-error':skillTextError}">
                                                    <immiInput :disabled="permDocPreFilledKyes.indexOf('skills')>-1" @keyEnter="addSkill=true;skillTextError=false;addPermNewSkill()" :wrapclass="'w-full'"  :display="true" cid="addSkill" :formscope="'jobOpptInfo'"  v-model="newSkill" :required="false" fieldName="altAcceptExpInYears" placeHolder=""  />
                                                    <!-- v-if="addSkill" -->
                                                    <span   @click="addPermNewSkill()" class="add-more">Add</span>
                                                </div>
                                            </div>
                                            </div>
                                            </div>
                                            </template>
                                                  <div class="vx-col  w-full">
                                                  <!--  mb-10 <div class="form_group">
                                                  <label class="form_label">Description<em >*</em></label>
                                                  <vs-textarea name="perm-jobDescription" v-model="jobDetails.description" v-validate="'required'"  class="w-full" :data-vv-as="'Description'" /> -->
                                                  <!-- <ckeditor :disabled="permDocPreFilledKyes.indexOf('description')>-1"  name="perm-jobDescription" v-model="jobDetails.description" v-validate="'required'"  class="w-full" :data-vv-as="'Description'"  :editor="editor" :config="editorConfig"></ckeditor>

                                                  <p v-show="errors.has('permJobDetailsform.perm-jobDescription')" class="text-danger text-sm"><em>* </em>Description is required</p>
                                                  </div> -->
                                                  <quillTextEditor :wrapclass="'form_group'" :fieldName="'perm-jobDescription'" :required="[50].indexOf(getUserRoleId)>-1?false:true" :cid="'description'"
                                                    :customValidNotRequire="false" v-model="jobDetails.description" :canSpellCheck="true" label="Description" 
                                                    placeHolder="Description" :vvas="'Description'" :disabled="permDocPreFilledKyes.indexOf('description')>-1"
                                                    />



                                                  </div>

                                                <br>
                                              <immiswitchyesno :display="true" :wrapclass="'vx-col md:w-1/2'" :fieldsArray="questionnaireDetails" :cid="'fullTimePosition'" formscope="fullTimePosition" v-model="jobDetails.fullTimePosition" fieldName="fullTimePosition" label="Is this a full-time position? " placeHolder="" />
                                              <immiswitchyesno :display="true"  :wrapclass="'vx-col md:w-1/2'" :fieldsArray="questionnaireDetails" :cid="'permanentPosition'" formscope="permanentPosition" v-model="jobDetails.permanentPosition" fieldName="permanentPosition" label="Is this a permanent position? " placeHolder="" />
                                              <immiswitchyesno v-if="false" :display="true"  :wrapclass="'vx-col md:w-1/2'" :fieldsArray="questionnaireDetails" :cid="'newPosition'" formscope="newPosition" v-model="jobDetails.newPosition" fieldName="newPosition" label="Is this a new position? " placeHolder="" />
                                              <div class="vx-col w-full">
                                                <div >
                                                  <h3 class="small-header">Work Address</h3>
                                                  <template v-for="(address ,index) in petition.jobDetails['workAddresses']">
                                                  <addressField :key="index" :display="true" :fieldsArray="questionnaireDetails":disableCountry="checkProperty(petition.jobDetails['workAddresses'][index], 'countryId') == 231" formscope="permJobDetailsform" :showaptType="true" :addFormContainerCls="false" :validationRequired="true" :countries="countries" v-model="jobDetails['workAddresses'][index]" :cid="'beneficiaryInfoaddress'+index" />
                                                  </template>
                                                </div>
                                              </div>
                                              <div class="vx-col  w-full">
                                              <span class="divider mt-0 mb-5"></span>
                                            </div>
                                            <h3 class="small-header w-full pl-4 pt-0 mt-0">Minimum Level Education</h3>
                                            <selectField :wrapclass="'md:w-1/2'" :required="true"  cid="Education"  :formscope="'permJobDetailsform'" :optionslist="educationTypes" v-model="jobDetails.minDegreeDetails" @input="jobDetails.minDegree=jobDetails.minDegreeDetails['id'];clearMinDegreeDetails()"   fieldName="Education" label="Minimum Education" placeHolder="Select Education"   />  
                                            <div class="vx-col  w-full mb-10" v-if="checkProperty(jobDetails, 'minDegreeDetails', 'id') == 8">
                                              <div class="form_group">
                                                <!-- <label class="form_label">Description<em >*</em></label>
                                                <ckeditor :disabled="permDocPreFilledKyes.indexOf('minDegreeDetailsOther')>-1?true:false"  name="perm-minDegreeDetailsOther" v-model="jobDetails.minDegreeDetailsOther" v-validate="'required'"  class="w-full" :data-vv-as="'Description'"  :editor="editor" :config="editorConfig"></ckeditor>
                                                <p v-show="errors.has('permJobDetailsform.perm-minDegreeDetailsOther')" class="text-danger text-sm"><em>* </em>Description is required</p> -->
                                                <quillTextEditor :wrapclass="'form_group'" :formscope="'permJobDetailsform'" :fieldName="'perm-minDegreeDetailsOther'" :required="true" :cid="'description'"
                                                    :customValidNotRequire="false" v-model="jobDetails.minDegreeDetailsOther" :canSpellCheck="true" label="Description" 
                                                    placeHolder="Description" :vvas="'Description'" :disabled="permDocPreFilledKyes.indexOf('minDegreeDetailsOther')>-1?true:false"
                                                    />
                                              </div>
                                            </div>
                                            <immiInput :disabled="permDocPreFilledKyes.indexOf('majorFieldsOfStudy')>-1"  :wrapclass="'md:w-1/2'" :display="true" :cid="'majorFieldsOfStudy'" :formscope="'permJobDetailsform'"  v-model="jobDetails.majorFieldsOfStudy" :required="true" fieldName="majorFieldsOfStudy" label="Major Field of Study" placeHolder="Major Field of Study"   />
                                            <immiInput :disabled="permDocPreFilledKyes.indexOf('expInYears')>-1" :onlyNumbers="true" :allowFloatingPoint="false" :wrapclass="'md:w-1/2 custom_form_group'" :display="true" cid="expInYears" :formscope="'permJobDetailsform'"  v-model="jobDetails.expInYears" :required="true" fieldName="expInYears" label="Experience in Months" placeHolder="Experience"  :maxLength="5" />

                                              <div class="vx-col  w-full">
                                                  <span class="divider mt-0 mb-5"></span>
                                                </div>
                                              <h3 class="small-header w-full pl-4 pt-0 mt-0">Alternate Level Education</h3>
                                            <immiswitchyesno :display="true" :wrapclass="'vx-col md:w-full'" :fieldsArray="[]" @input="clearAlternateFields()"
                                            :cid="'isAltCombOfEduAndExpAccept'" formscope="permJobDetailsform" v-model="jobDetails.isAltCombOfEduAndExpAccept"
                                            fieldName="isAltCombOfEduAndExpAccept" label="Is there an alternate combination of education and experience that is acceptable?" placeHolder="" />

                                            <selectField v-if="checkProperty(jobDetails, 'isAltCombOfEduAndExpAccept')" :isDisabled="permDocPreFilledKyes.indexOf('altLevelOfEduDetails') > -1" :wrapclass="'md:w-1/2'"
                                            :required="true" cid="altLevelOfEduDetails" :formscope="'permJobDetailsform'" :optionslist="educationTypes"
                                            v-model="jobDetails.altLevelOfEduDetails"
                                            @input="jobDetails.altLevelOfEdu = jobDetails.altLevelOfEduDetails['id'];clearAltLevelOfEduDetails()" fieldName="altLevelOfEduDetails"
                                            label="Alternate Level Education" placeHolder="Select Education" /> 

                                            <div class="vx-col  w-full mb-10" v-if="checkProperty(jobDetails, 'isAltCombOfEduAndExpAccept') && checkProperty(jobDetails, 'altLevelOfEduDetails', 'id') == 8">
                                              <div class="form_group">
                                                <!-- <label class="form_label"> Description <em>*</em></label>
                                                <ckeditor
                                                 :disabled="(permDocPreFilledKyes.indexOf('altLevelOfEduDetailsOther') > -1 && jobDetails.altLevelOfEduDetailsOther)?true:false"
                                                  name="perm-altLevelOfEduDetailsOther" v-model="jobDetails.altLevelOfEduDetailsOther" v-validate="'required'"
                                                  class="w-full" :data-vv-as="'Description'" :editor="editor" :config="editorConfig"></ckeditor>

                                                <p v-show="errors.has('permJobDetailsform.perm-altLevelOfEduDetailsOther')" class="text-danger text-sm"><em>*
                                                  </em>Description is required</p> -->
                                                  <quillTextEditor :wrapclass="'form_group'" :formscope="'permJobDetailsform'" :fieldName="'perm-altLevelOfEduDetailsOther'" :required="true" :cid="'description'"
                                                    :customValidNotRequire="false" v-model="jobDetails.altLevelOfEduDetailsOther" :canSpellCheck="true" label="Description" 
                                                    placeHolder="Description" :vvas="'Description'" :disabled="(permDocPreFilledKyes.indexOf('altLevelOfEduDetailsOther') > -1 && jobDetails.altLevelOfEduDetailsOther)?true:false"
                                                    />
                                              </div>
                                            </div>
                                            <immiInput v-if="checkProperty(jobDetails, 'isAltCombOfEduAndExpAccept')"
                                            :disabled="permDocPreFilledKyes.indexOf('altAcceptExpInYears') > -1" 
                                            :onlyNumbers="true"  :wrapclass="'md:w-1/2 custom_form_group'"
                                            :display="true" cid="altAcceptExpInYears" :formscope="'permJobDetailsform'" v-model="jobDetails.altAcceptExpInYears"
                                            :required="true" fieldName="altAcceptExpInYears" label="No of years experience acceptable" placeHolder="No of years experience"
                                            :maxLength="5" />

                                            <immiswitchyesno :display="true" :wrapclass="'vx-col md:w-full'" :fieldsArray="[]"  @input="clearAlternateOccupationFields()"
                                            :cid="'isExpInAltOccuAccept'" formscope="permJobDetailsform" v-model="jobDetails.isExpInAltOccuAccept"
                                            fieldName="isExpInAltOccuAccept" label="Is experience in an alternate occupation acceptable?" placeHolder="" />

                                            <immiInput v-if="checkProperty(jobDetails, 'isExpInAltOccuAccept')"
                                            :disabled="permDocPreFilledKyes.indexOf('noOfExpMonthsInAltOccu') > -1" 
                                            :onlyNumbers="true"  :wrapclass="'md:w-1/2 custom_form_group'"
                                            :display="true" cid="noOfExpMonthsInAltOccu" :formscope="'permJobDetailsform'" v-model="jobDetails.noOfExpMonthsInAltOccu"
                                            :required="true" fieldName="noOfExpMonthsInAltOccu" label="No of months experience in alternate occupation" placeHolder="No of months experience"
                                            :maxLength="5" />

                                            <div class="vx-col  w-full">
                                              <span class="divider mt-0 mb-5"></span>
                                            </div>
                                            <h3 class="small-header w-full pl-4 pt-0 mt-0">Highest level achieved as required by the requested job opportunity</h3>
                                            <selectField  :isDisabled="permDocPreFilledKyes.indexOf('eduHighLevReqJobOppDetails') > -1" :wrapclass="'md:w-1/2'"
                                            :required="[50].indexOf(getUserRoleId)>-1?false:true" cid="eduHighLevReqJobOppDetails" :formscope="'permJobDetailsform'" :optionslist="educationTypes"
                                            v-model="jobDetails.eduHighLevReqJobOppDetails" @input="clearEduHighLevReqJobOppDetails()"
                                            fieldName="eduHighLevReqJobOppDetails"
                                            label="Highest level achieved education" placeHolder="Select Education" />

                                            <div class="vx-col  w-full mb-10" v-if="checkProperty(jobDetails, 'eduHighLevReqJobOppDetails', 'id') == 8">
                                              <div class="form_group">
                                                <!-- <label class="form_label"> Description <em>*</em></label>
                                                <ckeditor
                                                 :disabled="(permDocPreFilledKyes.indexOf('eduHighLevReqJobOppDetailsOther') > -1 && jobDetails.eduHighLevReqJobOppDetailsOther)?true:false"
                                                  name="perm-eduHighLevReqJobOppDetailsOther" v-model="jobDetails.eduHighLevReqJobOppDetailsOther" v-validate="'required'"
                                                  class="w-full" :data-vv-as="'Description'" :editor="editor" :config="editorConfig"></ckeditor>

                                                <p v-show="errors.has('permJobDetailsform.perm-eduHighLevReqJobOppDetailsOther')" class="text-danger text-sm"><em>*
                                                  </em>Description is required</p> -->
                                                  <quillTextEditor :wrapclass="'form_group'" :formscope="'permJobDetailsform'" :fieldName="'perm-eduHighLevReqJobOppDetailsOther'" :required="[50].indexOf(getUserRoleId)>-1?false:true" :cid="'description'"
                                                    :customValidNotRequire="false" v-model="jobDetails.eduHighLevReqJobOppDetailsOther" :canSpellCheck="true" label="Description" 
                                                    placeHolder="Description" :vvas="'Description'" :disabled="(permDocPreFilledKyes.indexOf('eduHighLevReqJobOppDetailsOther') > -1 && jobDetails.eduHighLevReqJobOppDetailsOther)?true:false"
                                                    />
                                              </div>
                                            </div>

                                            <immiInput :disabled="permDocPreFilledKyes.indexOf('eduMajorFieldOfStudy') > -1" :wrapclass="'md:w-1/2'"
                                            :display="true" :cid="'eduMajorFieldOfStudy'" :formscope="'permJobDetailsform'"
                                            v-model="jobDetails.eduMajorFieldOfStudy" :required="[50].indexOf(getUserRoleId)>-1?false:true" fieldName="eduMajorFieldOfStudy"
                                            label="Specify Major Field of Study" placeHolder="Specify Major Field of Study" />

                                            <immiInput :disabled="permDocPreFilledKyes.indexOf('eduCompleteYear') > -1" :wrapclass="'md:w-1/2'" :maxLength="4"
                                            :display="true" :cid="'eduCompleteYear'" :formscope="'permJobDetailsform'" :onlyNumbers="true" :allowFloatingPoint="false"
                                            v-model="jobDetails.eduCompleteYear" :required="[50].indexOf(getUserRoleId)>-1?false:true" fieldName="eduCompleteYear"
                                            label="Year relevant education completed" placeHolder="Year relevant education completed" />

                                            <!-- <datepickerField :isDisabled="permDocPreFilledKyes.indexOf('eduCompleteYear') > -1"wrapclass="md:w-1/2"  cid="eduCompleteYear"
                                            :display="true" v-model="jobDetails.eduCompleteYear" :formscope="'permJobDetailsform'"
                                            fieldName="  " label="Year relevant education completed" :validationRequired="true" /> -->

                                            <immiInput :disabled="permDocPreFilledKyes.indexOf('eduInstitution') > -1" :wrapclass="'md:w-1/2'"
                                            :display="true" :cid="'eduInstitution'" :formscope="'permJobDetailsform'"
                                            v-model="jobDetails.eduInstitution" :required="[50].indexOf(getUserRoleId)>-1?false:true" fieldName="eduInstitution"
                                            label="Institution where relevant education" placeHolder="Institution where relevant education" />

                                            <div class="vx-col w-full">
                                              <div>
                                                <h3 class="small-header">Institution Address</h3>
                                                <addressField  :display="true" :fieldsArray="[]"
                                                formscope="permJobDetailsform" :showaptType="true" :addFormContainerCls="false"
                                                :validationRequired="[50].indexOf(getUserRoleId)>-1?false:true" :countries="countries"
                                                v-model="jobDetails['eduAddress']" :cid="'eduactionAddress'" />
                                              </div>
                                            </div>



                                          



                                          
                                          </div>
                                      </div>

                                        <div v-show="formerrorsMsg">
                                        <vs-alert color="warning" class="warning-alert reg-warning-alert no-border-radius" icon-pack="IntakePortal"
                                        icon="IP-information-button" active="true">{{ formerrorsMsg }}</vs-alert>
                                        </div>
                                        
                                      <div class="popup-footer relative">
                                        <span v-if="updatingJobDetails" class="loader" ><img src="@/assets/images/main/loader.gif"  /></span>
                                        <vs-button  color="dark"  @click="editJobDetails = false ;setJobDetailsData();" class="cancel" type="filled" >Cancel</vs-button>
                                      <vs-button color="success" class="save" type="filled"  @click="updateJobDetails()">Update</vs-button>
                                      </div>

                                    </form>
                                  </div>
                                </vs-card>
                              </div>
                            </vs-col>
                        </vs-row>
                        </div>

                        <!-----Details Section && !checkProperty(petition ,'permId')-->
                      <div class="vx-col w-full p-0  " v-if="!editJobDetails ">
                              <div class="dependent-block_wrap">
                                  <div class="dependent-block w-full">
                                      <div class="dependent-title">
                                          <h3 class="job_details_heading">
                                              Job Details
                                          </h3>
                                          <span  class="edit__btn" v-if="!checkUscisIsCompleted" @click="editMe()" >
                                             <img src="@/assets/images/main/icon-edit.svg" />Edit
                                          </span>
                                      </div>
                                      <div class="dependent_details job_info_details"> 
                                          <ul>
                                            <!-- checkProperty(child,'consularProcessing') == true || checkProperty(child,'consularProcessing') == false " -->
                                              <li v-if="checkProperty(petition,'jobDetails','jobTitle')"> Job Title <span>{{checkProperty(petition,'jobDetails','jobTitle')}}</span></li>
                                              <li v-if="checkProperty(petition,'jobDetails','fullTimePosition')== true || checkProperty(petition,'jobDetails','fullTimePosition')== false">Full Time Position <span>{{checkProperty(petition,'jobDetails','fullTimePosition') | booleanFormat}}</span></li>
                                              <li v-if="checkProperty(petition,'jobDetails','hoursPerWeek')">Work Hours per Week <span>{{checkProperty(petition,'jobDetails','hoursPerWeek')}}</span></li>
                                              <li v-if="checkProperty(petition,'jobDetails','wageRate')">Wage Rate <span>{{checkProperty(petition,'jobDetails','wageRate') | formatprice}}</span></li>
                                              
                                              <li v-if="checkProperty(petition,'jobDetails','socDetails') && checkProperty(petition['jobDetails'],'socDetails' ,'name')">SOC Code Details <span>{{checkProperty(petition['jobDetails'],'socDetails' ,'name')}}<template v-if="checkProperty(petition['jobDetails'],'socDetails' ,'designation')"></template> ({{ checkProperty(petition['jobDetails'],'socDetails' ,'designation') }})</span></li>

                                              <li v-if="checkProperty(petition,'jobDetails','payFrequency')">Pay Frequency <span>{{checkProperty(petition,'jobDetails','payFrequency')}}</span></li>
                                              <li v-if="checkProperty(petition ,'classification')"> Classification <span>{{checkProperty(petition ,'classification')}}</span></li>
                                            <li v-if="checkProperty(petition ,'categoryDetails','name')"> Category <span>{{checkProperty(petition ,'categoryDetails','name')}}</span></li>
                                            <!-- <li v-if="checkProperty(petition,'jobDetails','i140PriorityDate')">Priority Date of I-140 <span>{{checkProperty(petition,'jobDetails','i140PriorityDate') | formatDate}}</span></li> -->
                                            <li v-if="checkProperty(petition,'jobDetails','permanentPosition')==true || checkProperty(petition,'jobDetails','permanentPosition')==false"> Permanent Position<span>{{checkProperty(petition,'jobDetails','permanentPosition')| booleanFormat}} </span></li>
                                              <!--  <li v-if="checkProperty(petition,'jobDetails','newPosition')== true || checkProperty(petition,'jobDetails','newPosition')== false"> New Position<span>{{checkProperty(petition,'jobDetails','newPosition')| booleanFormat}} </span></li> -->
                                            <li v-if="checkProperty(petition,'jobDetails','isExpRequired')">Is experience in the job offered required for the job<span>{{checkProperty(petition,'jobDetails','isExpRequired')| booleanFormat}}</span></li>
                                            <li v-if="checkProperty(petition,'jobDetails','noOfExpMonths')">No of months of experience<span>{{checkProperty(petition,'jobDetails','noOfExpMonths')}}</span></li>
                                            <li class="w-full" v-if="checkProperty(petition['jobDetails'] ,'skills' ,'length')>0">Skills
                                              <ul class="default_list_items skills_list" >
                                                  <li v-for=" (skil ,ind) in petition['jobDetails']['skills']" :key="ind">
                                                      <span>{{skil}}</span>
                                                  </li>
                                              </ul>                                    
                                            </li>
                                            <li v-if="checkProperty(petition,'jobDetails','description')"
                                              class="w-full editor_view_wrap mb-0" >Job Description 
                                                <div class="editor_view pb-0" v-html="checkProperty(petition,'jobDetails','description')"></div>
                                            </li>
                                            <template v-if="checkProperty(petition['jobDetails']['workAddresses'], 'length') >0">
                                              <template v-for="(item,inder) in petition['jobDetails']['workAddresses']">
                                                <li v-if="item" class="w-full">Work Address <span v-html="$options.filters.addressformat(item)"></span> </li>
                                              </template>
                                            </template>
                                            
                                            <template v-if="checkProperty(petition,'jobDetails','minDegree')|| checkProperty(petition,'jobDetails','majorFieldsOfStudy') ||
                                              checkProperty(petition,'jobDetails','expInYears')" >
                                              <li class=" w-full divider mt-0 mb-2"></li>
                                              <h3 class="small-header w-full  pt-0 mb-5">Minimum Level Education</h3>
                                              <li v-if="checkProperty(petition,'jobDetails','minDegree')">Minimum Education <span>{{checkProperty(petition,'jobDetails','minDegree') | formatML(highestDegreeList)}}</span></li>
                                              <li v-if="checkProperty(petition,'jobDetails','minDegree') == 8 && checkProperty(petition,'jobDetails','minDegreeDetailsOther')"
                                              class="w-full editor_view_wrap mb-0" >Description 
                                                <div class="editor_view pb-0" v-html="checkProperty(petition,'jobDetails','minDegreeDetailsOther')"></div>
                                              </li>
                                              <li v-if="checkProperty(petition,'jobDetails','majorFieldsOfStudy')">Major Field of Study <span>{{checkProperty(petition,'jobDetails','majorFieldsOfStudy')}}</span></li>
                                              <li v-if="checkProperty(petition,'jobDetails','expInYears')">Experience in Months <span>{{checkProperty(petition,'jobDetails','expInYears')}}</span></li>
                                            </template>
                                            <template v-if="(checkProperty(petition,'jobDetails','isAltCombOfEduAndExpAccept') == true || checkProperty(petition,'jobDetails','isAltCombOfEduAndExpAccept') == false)||
                                            (checkProperty(petition,'jobDetails','altLevelOfEduDetails') && checkProperty(petition['jobDetails'],'altLevelOfEduDetails', 'name'))||
                                            checkProperty(petition,'jobDetails','altAcceptExpInYears') || checkProperty(petition,'jobDetails','noOfExpMonthsInAltOccu') ||
                                            (checkProperty(petition,'jobDetails','isExpInAltOccuAccept') == true || checkProperty(petition,'jobDetails','isExpInAltOccuAccept') == false) ">
                                              <li class=" w-full divider"></li>
                                              <h3 class="small-header w-full  mt-0 mb-2">Alternate Level Education</h3>
                                              
                                              <li v-if="checkProperty(petition,'jobDetails','isAltCombOfEduAndExpAccept') == true || checkProperty(petition,'jobDetails','isAltCombOfEduAndExpAccept') == false ">Is there an alternate combination of education and experience that is acceptable<span>{{checkProperty(petition,'jobDetails','isAltCombOfEduAndExpAccept')| booleanFormat}}</span></li>
                                              
                                              <li v-if="checkProperty(petition,'jobDetails','isAltCombOfEduAndExpAccept') && checkProperty(petition,'jobDetails','altLevelOfEduDetails') && checkProperty(petition['jobDetails'],'altLevelOfEduDetails', 'name')">Alternate Level Education<span>{{checkProperty(petition['jobDetails'],'altLevelOfEduDetails', 'name')}}</span></li>
                                              <li v-if="checkProperty(petition,'jobDetails','isAltCombOfEduAndExpAccept') && ( checkProperty(petition,'jobDetails','altLevelOfEduDetails') && checkProperty(petition['jobDetails'],'altLevelOfEduDetails', 'id') == 8) && checkProperty(petition,'jobDetails','altLevelOfEduDetailsOther')  "
                                                class="w-full editor_view_wrap mb-0">Description 
                                                  <div class="editor_view pb-0" v-html="checkProperty(petition,'jobDetails','altLevelOfEduDetailsOther')"></div>
                                              </li>
                                              <li v-if="checkProperty(petition,'jobDetails','isAltCombOfEduAndExpAccept') && checkProperty(petition,'jobDetails','altAcceptExpInYears')">No of years experience acceptable<span>{{checkProperty(petition,'jobDetails','altAcceptExpInYears')}}</span></li>
                                              <li v-if="checkProperty(petition,'jobDetails','isExpInAltOccuAccept') == true || checkProperty(petition,'jobDetails','isExpInAltOccuAccept') == false">Is experience in an alternate occupation acceptable<span>{{checkProperty(petition, 'jobDetails', 'isExpInAltOccuAccept')| booleanFormat}}</span></li>
                                              <li v-if="checkProperty(petition,'jobDetails','isExpInAltOccuAccept') && checkProperty(petition,'jobDetails','noOfExpMonthsInAltOccu')">No of months experience in alternate occupation<span>{{checkProperty(petition,'jobDetails','noOfExpMonthsInAltOccu')}}</span></li>
                                            </template>
                                           
                                            <template v-if="(checkProperty(petition,'jobDetails','eduHighLevReqJobOppDetails') && checkProperty(petition['jobDetails'],'eduHighLevReqJobOppDetails', 'name'))||
                                            checkProperty(petition,'jobDetails','eduMajorFieldOfStudy') || checkProperty(petition,'jobDetails','eduCompleteYear') ||
                                            checkProperty(petition,'jobDetails','eduInstitution') || 
                                            (checkProperty(petition ,'jobDetails', 'eduAddress' )  && 
                                            (  checkProperty(petition['jobDetails']['eduAddress'] ,'address' ,'line1' )
                                              || checkProperty(petition['jobDetails']['eduAddress'] ,'locationDetails' ,'name' )
                                              || checkProperty(petition['jobDetails']['eduAddress'] ,'stateDetails' ,'name' )
                                              || checkProperty(petition['jobDetails']['eduAddress'] ,'countryDetails' ,'name' )
                                             )) 
                                          ">
                                              <li class=" w-full divider mt-0 mb-2"></li>
                                              <h3 class="small-header w-full  pt-0 mb-5">Highest level achieved as required by the requested job opportunity</h3>
                                              
                                              <li v-if="checkProperty(petition,'jobDetails','eduHighLevReqJobOppDetails') && checkProperty(petition['jobDetails'],'eduHighLevReqJobOppDetails', 'name')">Highest level achieved education<span>{{checkProperty(petition['jobDetails'],'eduHighLevReqJobOppDetails', 'name')}}</span></li>
                                              <li v-if="( checkProperty(petition,'jobDetails','eduHighLevReqJobOppDetails') && checkProperty(petition['jobDetails'],'eduHighLevReqJobOppDetails', 'id') == 8) && checkProperty(petition,'jobDetails','eduHighLevReqJobOppDetailsOther')  "
                                                class="w-full editor_view_wrap mb-0" >Description 
                                                  <div class="editor_view pb-0" v-html="checkProperty(petition,'jobDetails','eduHighLevReqJobOppDetailsOther')"></div>
                                              </li>
                                              <li v-if="checkProperty(petition,'jobDetails','eduMajorFieldOfStudy')">Specify Major Field of Study<span>{{checkProperty(petition,'jobDetails','eduMajorFieldOfStudy')}}</span></li>
                                              <li v-if="checkProperty(petition,'jobDetails','eduCompleteYear')">Year relevant education completed<span>{{checkProperty(petition,'jobDetails','eduCompleteYear')}}</span></li>
                                              <li v-if="checkProperty(petition,'jobDetails','eduInstitution')">Institution where relevant education<span>{{checkProperty(petition,'jobDetails','eduInstitution')}}</span></li>
                                              <li v-if="checkProperty(petition,'jobDetails','eduAddress')" class="w-full">Institution Address <span v-html="$options.filters.addressformat(petition['jobDetails']['eduAddress'])"></span>
                                              </li>
                                            </template>
                                          </ul>
                                          <ul v-if="false">
                                             <li class="w-full" v-if="checkProperty(petition['jobDetails'] ,'skills' ,'length')>0 && false">Skills
                                            <ul class="default_list_items skills_list" >
                                                <li v-for=" (skil ,ind) in petition['jobDetails']['skills']" :key="ind">
                                                    <span>{{skil}}</span>
                                                </li>
                                            </ul>                                    
                                          </li>
                                          </ul>
                                          <template v-if="false">
                                            <ul v-for="(item,inder) in petition['jobDetails']['workAddresses']" :key="inder">
                                                <li v-if="item" class="w-full">Work Address <span v-html="$options.filters.addressformat(item)"></span>
                                                </li>
                                            </ul>
                                        </template>
                                                             
                                      </div>
                                      <div class="editor_view_wrap " v-if="checkProperty(petition,'jobDetails','description') && false">
                                          <h3 class="sub-title">Job Description</h3>
                                          <div class="editor_view" v-html="petition['jobDetails']['description']"></div>
                                      </div>
                                  </div>
                              </div>
                                  
                      </div>
                    </template>
                    </div>
                    </div>   
                      

                </vs-tab>
              </vs-tabs>                

            </div>
        </vs-col>
        </vs-row>
      </div>
    </div> 
  </div>                             








  
    </template>
<script>

//import FileUpload from "vue-upload-component/src";
import draggable from "vuedraggable";
import VuePerfectScrollbar from "vue-perfect-scrollbar";

import selectField from "@/views/forms/fields/simpleselect.vue";
import immiswitchyesno from "@/views/forms/fields/switchyesno.vue";

import addressField from "@/views/forms/fields/address.vue";

import _ from "lodash";

import immiInput from "@/views/forms/fields/simpleinput.vue";
import Vue from 'vue';
Vue.use( CKEditor );
import CKEditor from '@ckeditor/ckeditor5-vue2';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import FileUpload from "@/views/FileUpload.vue";
import quillTextEditor from "./forms/fields/quillTextEditor.vue";
import datepickerField from "@/views/forms/fields/datepicker.vue";
export default {
  provide() {
        return {
            parentValidator: this.$validator,
        };
    },
    components: {
        FileUpload,
        draggable,
        VuePerfectScrollbar,
        selectField,
        immiswitchyesno,
        addressField,
        immiInput,
        quillTextEditor,
        datepickerField
    },
    mounted(){
      this.$store.dispatch("getmasterdata", "education_types").then((response) => {
          this.highestDegreeList = response;
      });
               
      this.$store.dispatch("getcountries").then((response) => {
                this.countries = response;

            });
            
      this.getMasterSocList();
     setTimeout(() => {
       this.setJobDetailsData();
       
     }, 10);
     this.getEducationList();
     if(this.checkProperty(this.petition,'permDocs' ,'length')>0){
      this.permDolDocs = this.checkProperty(this.petition,'permDocs');
     }
  
    },
    data() {
    return {
      permDocPreFilledKyes:[],
      permDocuments:[],
      permDolDocs:[], 
      permDocFormatError:'',
      draftExtractInfo:null,

       uploading:false,
      skillTextError:false,
      newSkill:'',
      addSkill:true,
      educationTypes:[],
      highestDegreeList:[],
      editor: ClassicEditor,
 editorConfig: {
     toolbar: [ 'bold', 'italic', '|', 'undo','redo'  ,'NumberedList', 'BulletedList', ],
 },

      payFrequencyList: ["Hour", "Week", "Month", "Year"],
      updatingJobDetails:false,
      editJobDetails:false,
      formerrorsMsg:'',
      countries: [],
      uploaddocType: "",
      masterSocList:[],
      jobDetails: {
        // i140PriorityDate:null,

        minDegreeDetailsOther:null,
        isExpRequired:null,
        noOfExpMonths:'',
        isAltCombOfEduAndExpAccept:null,
        altLevelOfEduDetails:null,
        altLevelOfEduDetailsOther:'',
        altAcceptExpInYears:null,
        isExpInAltOccuAccept:null,
        noOfExpMonthsInAltOccu:null,
        eduHighLevReqJobOppDetails:null,
        eduHighLevReqJobOppDetailsOther:'',
        eduMajorFieldOfStudy:'',
        eduCompleteYear:null,
        eduInstitution:'',
        eduAddress:{
          line1: null,
          line2: null,
          aptType: null,
          locationId: null,
          locationDetails: null,
          stateId: null,
          stateDetails: null,
          countryId: null,
          countryDetails: null,
          zipcode: null
        },

            socCode:'',
            socDetails:null,
            permApplicationNo:'',

            jobTitle: '',
            minDegreeDetails:null,
          minDegree:null,
          skills:[],
          majorFieldsOfStudy:'',
          expInYears:null,

            workAddresses: [
            {
                    line1: null,
                    line2: null,
                    aptType: null,
                    locationId: null,
                    locationDetails: null,
                    stateId: null,
                    stateDetails: null,
                    countryId: 231,
                     countryDetails: {
                      "id": 231,
                      "shortName": "US",
                      "name": "United States",
                      "phoneCode": 1,
                      "order": 1,
                      "currencySymbol": "$",
                      "currencyCode": "USD",
                      "zipcodeLength": 5
                    },
                    zipcode: null
                }
            ],

            fullTimePosition: false,

            hoursPerWeek: '',

            wageRate: '',

            payFrequency: '', // Year, Month, Bi-Weekly, Week, Hour

            description: '',

            permanentPosition: false,

            newPosition: false

        },
    }},
    props: {
      questionnaireDetails:[],
      value:null,
        petition: {
            type: Object,
            default: null,
        },
        currentRole: null,
    },
    methods:{
      clearAlternateFields(){
        if(!this.checkProperty(this.jobDetails,'isAltCombOfEduAndExpAccept')){
          this.jobDetails['altLevelOfEduDetails'] = null;
          this.jobDetails['altLevelOfEduDetailsOther'] = '';
          this.jobDetails['altAcceptExpInYears'] = null;
        }
      },
      clearAlternateOccupationFields(){
        if(!this.checkProperty(this.jobDetails,'isExpInAltOccuAccept')){
          this.jobDetails['noOfExpMonthsInAltOccu'] = null;
        }
      },
      clearMinDegreeDetails(){
        if(this.checkProperty(this.jobDetails, 'minDegreeDetails', 'id') != 8 ){
          this.jobDetails.minDegreeDetailsOther = '';
        }
      },
      clearAltLevelOfEduDetails(){
        if(this.checkProperty(this.jobDetails, 'altLevelOfEduDetails', 'id') != 8 ){
          this.jobDetails.altLevelOfEduDetailsOther = '';
        }
      },
      clearEduHighLevReqJobOppDetails(){
        if(this.checkProperty(this.jobDetails, 'eduHighLevReqJobOppDetails', 'id') != 8 ){
          this.jobDetails.eduHighLevReqJobOppDetailsOther = '';
        }
      },
      updateData(docs, category){
      if(category == 'permDocuments'){
        this.permDolDocs= docs;
        if(this.checkProperty(this.permDolDocs, 'length')>0){
          if(this.checkProperty(this.petition,'permDocs','length')>0){
            if(this.checkProperty(this.permDolDocs,'length')>0){
              let newlyUploadedDocumet = this.permDolDocs[0];
              let existsDocument =this.petition['permDocs'][0];
              if(this.checkProperty(newlyUploadedDocumet,'path') != this.checkProperty(existsDocument,'path')){
                this.$vs.loading();
                this.prefillPermDocData();

              }
            }

          }else{
            this.$vs.loading();
            this.prefillPermDocData();

          }
          
        }
      }
    },
      editMe(){
        this.draftExtractInfo =null;
        this.permDocPreFilledKyes = [];
        this.permDolDocs = _.cloneDeep(this.petition['permDocs']);
        this.permDocuments = this.permDolDocs
        this.setJobDetailsData();
        setTimeout(()=>{
          this.editJobDetails =true
        },5);
      },

   
      remove(item, data, filindex) {
          data.splice(filindex, 1);
          this.removeFileFromS3(item)

        },
        updatedexpInYears(){
        if(this.checkProperty( this.jobDetails, 'expInYears' )){
          this.jobDetails.expInYears = parseInt(this.jobDetails.expInYears);
        }
        

      },
        prefillPermDocData(){
      this.draftExtractInfo =null;
      let _self =this;
      this.permDocFormatError ='';
      var _dt;
      this.permDocPreFilledKyes =[];
      this.$validator.reset();
    if(this.permDolDocs.length>0){
    this.uploading = true;  
    let path ="/common/extract-data-from-pdf";
    let postData ={
      "docType": "perm",
      documents:[],
    };
    
    //postData['documents'] = this.pwdResponse['documents']
    _.forEach(this.permDolDocs ,(doc)=>{
      postData['documents'].push(doc.path)
        //return doc.path;
    })
    this.$vs.loading();
    this.$store.dispatch('commonAction', {"data":postData ,"path":path})
        .then((response)=>{
          _self.uploading = false;  
          let responseData = response['jobDetails'];
          _dt = _.cloneDeep(response['jobDetails']);
          
          _self.draftExtractInfo =response;
          _.forEach(this.jobDetails , (item ,key)=>{
            
            if(_.has(responseData ,key) && responseData[key]){
                
              
                if(key=="wageRate" && responseData[key]){
                  let wageRate = responseData[key];
                  const specialCharsRegex = /[^0-9.]/g;
                  // Use the replace() method to replace all special characters with an empty string
                  wageRate = wageRate.replace(specialCharsRegex, "");

                  _self.jobDetails['wageRate'] = parseFloat(wageRate);
                }else if( key=="minDegree" , this.checkProperty(responseData ,'minDegree' )){
                  _self.jobDetails['minDegree'] = responseData['minDegree'];
                  _self.jobDetails['minDegreeDetails'] = _.find(_self.educationTypes, {"id": parseInt(responseData['minDegree'])});
                  _self.permDocPreFilledKyes.push("minDegree")
                }else if(key=="socCode"){
                  _self.permDocPreFilledKyes.push("socDetails");
                  _self.jobDetails['socDetails'] = _.find(_self.masterSocList, {"id":parseInt(responseData[key])});
                
                }else if(key=="skills") {

                  let skils = responseData[key].split(',');
                  _self.jobDetails['skills'] = _.map(skils,(skil)=>skil.trim())
                  if(_self.checkProperty(_self.jobDetails, 'skills', 'length' )>0){
                    _self.permDocPreFilledKyes.push(key);
                  }
                
                }else{
                  _self.jobDetails[key] = responseData[key];
                  _self.permDocPreFilledKyes.push(key);
                }
                _self.updatedexpInYears();


              }
          });

      
          
              _self.$vs.loading.close();

        }).catch((errr)=>{
          _self.permDocFormatError =errr
         // this.prefillJobDetailsError = errr
          //this.showToster({message:errr,isError:true });
          _self.uploading = false;  
          _self.$vs.loading.close();
        });
      }else{
        _self.$vs.loading.close();
      }

       },
       uploadPermDocs(fils, category='') {
       
          this.draftExtractInfo =null;
          this.pwdDocFormatError ='';
          let  model =_.cloneDeep(fils);
          this.permDocuments =[];
          var _current = this;
          // this.$vs.loading();
    
          let efiles = [];
          efiles = _.filter(model, (e) => {
            return e.url != null && e.url != "";
          });
          let nfiles = _.filter(model, (e) => {
            return e.url == null || e.url == undefined;
          });
    
          let mapper = nfiles.map(
            (item) =>
              (item = {
                name: item.name,
                file: item.file ? item.file : null,
                url: item.url ? item.url : "",
                path: item.path ? item.path : "",
                status: true,
                mimetype: item.type ? item.type : item.mimetype,
                status: true,
                uploadedBy: _current.checkProperty(_current.getUserData, 'userId'),
                uploadedByName: _current.checkProperty(_current.getUserData, 'name'),
                uploadedByRoleId: _current.getUserRoleId,
                uploadedByRoleName: _current.checkProperty(_current.getUserData, 'loginRoleName'),
                size:item.size ? item.size : null,
              })  
          );
          let tempFiles = [];
          if (mapper.length > 0) {
            this.uploading = true;
            let count = 0;
            mapper.forEach((doc, index) => {
              //rfeData:{}
              if( (category == 'RFE' || category == 'PWD' || category =='permDocuments') && !( doc.mimetype=='application/pdf' )  ){
               // this.pwdDocFormatError ="Upload only pdf documents";
                if(category =='permDocuments'){
                  this.permDocFormatError = "Upload only pdf documents";
                }
              
                this.uploading = false;   
                      
                return false;

              }
              let formData = new FormData();
              formData.append("files", doc.file);
              formData.append("secureType", "private");
              formData.append("getDetails", true);
              count++;
              
              this.$store.dispatch("uploadS3File", formData).then((response) => {
                response.data.result.forEach((urlGenerated) => {
                  //alert(JSON.stringify(urlGenerated))
                  //  this.CommentPayload.documents.push(urlGenerated)
                  // if (  _.has(urlGenerated, "name") &&  tempFiles.indexOf(urlGenerated["name"]) <= -1 ) {
                    tempFiles.push(urlGenerated["name"]);
                    if(category == 'permDocuments'){
                      this.permDolDocs =[];
                      this.permDolDocs.push(urlGenerated);
                      this.prefillPermDocData();
                    }else{
                      this.$vs.loading.close();
                    }
                    // if(category == 'delete'){
                    //   this.permDeleteDocs.push(urlGenerated);
                    // }
                    
                //   }
                  doc.url = urlGenerated;
                  doc.path = urlGenerated;
                  doc["mimetype"] = urlGenerated["mimetype"];
                  doc["type"] = urlGenerated["mimetype"];
                  delete doc.file;
                  mapper[index] = doc;
                });
                if (index >= mapper.length - 1) {
                  this.uploading = false;
                  // _current.$vs.loading.close();
                }
              });
            });
            if (efiles.length > 0) efiles.push(...mapper);
            //this.CommentPayload["documents"] = efiles
          }
        },

      updatedexpInYears(){
        if(this.checkProperty( this.jobDetails, 'expInYears' )){
          this.jobDetails.expInYears = parseInt(this.jobDetails.expInYears);
        }
        

      }, 
    addPermNewSkill(){
      
      
            this.skillTextError =false;
            if(this.newSkill && this.newSkill.trim() !=''){

                let skil = this.newSkill.trim();
                if(this.jobDetails['skills'].indexOf(skil) <=-1){
                    this.jobDetails['skills'].push(skil);
                }

               
                this.newSkill ='';
                this.addSkill =false;
            }else{
                this.skillTextError =true;
            }
        },
        removePermSkill(index ){
            
            this.jobDetails['skills'].splice(index ,1);
           // this.$emit('input', this.value);
        },
      getEducationList(){
            this.$store
                .dispatch("getmasterdata", "education_types")
                .then((response) => {
                    this.educationTypes = response;

                   // this.jobDetails =  this.value['jobDetails']; minDegree minDegreeDetails
                   if(this.checkProperty(this.value,'jobDetails','minDegree')){
                    this.jobDetails['minDegreeDetails'] = _.find( this.educationTypes,  { "id":parseInt(this.value['jobDetails']['minDegree'])});

                   }
                                     
                })
                },


      updateJobDetails(){
        let path="/petition/update-job-details";
        this.$validator.validateAll('permJobDetailsform').then((result) => {
          if(result){
            let postData ={
              "petitionId": "",
              "typeName": "",
              "subTypeName":"",
              "jobDetails":{}

            }
            postData['petitionId'] = this.checkProperty(this.petition ,'_id');
            postData['typeName'] = this.checkProperty(this.petition ,'typeDetails' ,'name');
            postData['subTypeName'] = this.checkProperty(this.petition ,'subTypeDetails' ,'name');
            postData['jobDetails'] = this.jobDetails;
          //  this.permDolDocs //this.draftExtractInfo
          if(this.checkProperty(this.permDolDocs,'length') >0){
            postData = Object.assign(postData,{"permDolDocs":[]});
            postData['permDocs'] = this.permDolDocs;
          }else if(this.checkProperty( this.petition,'permDocs' ,'length')>0){
            postData = Object.assign(postData,{"permDolDocs":[]});
            postData['permDocs'] = this.petition['permDocs'];
          }
          //checkProperty( petition,'permDocs' ,'length')>0
          if(this.draftExtractInfo){
            if( this.checkProperty(Object.keys(this.draftExtractInfo),'length' )>0 ){            
            postData = Object.assign(postData,{"draftExtractInfo":{}});
            postData['draftExtractInfo'] = this.draftExtractInfo;
          }
          }
            this.formerrorsMsg = '';
            this.updatingJobDetails =true;
          this.$store.dispatch("commonAction", {"data":postData ,"path":path}).then((response) => {
              this.showToster({message:response.message,isError:false });
              this.formerrorsMsg = '';
              this.updatingJobDetails =false;
              this.$emit("updatepetition" ,'PERM-INFO');
              this.editJobDetails = false 
            
          }).catch((error)=>{
               this.formerrorsMsg = error;
              this.updatingJobDetails =false;
          })
          }


        });

      },
      setJobDetailsData(){
        this.draftExtractInfo=null;
        this.permDocPreFilledKyes =[];
        setTimeout(() => {
          if(_.has(this.value ,'jobDetails')){
             // this.jobDetails =  this.value['jobDetails']; minDegree minDegreeDetails
              _.forEach(this.jobDetails, (item ,key)=>{
                if(_.has(this.value['jobDetails'],key)){
                  this.jobDetails[key] =_.cloneDeep(this.value['jobDetails'][key]);

                }

              });

              let addressItem ={
                            line1: null,
                            line2: null,
                            aptType: null,
                            locationId: null,
                            locationDetails: null,
                            stateId: null,
                            stateDetails: null,
                            countryId: null,
                            countryDetails: null,
                            zipcode: null
                        };
              if(!this.checkProperty( this.jobDetails ,'workAddresses' )  || this.checkProperty( this.jobDetails ,'workAddresses' ,'length')<=0){
                this.jobDetails['workAddresses'] = [addressItem];
              }


              let submitToUscisCompleted =false;
              if(this.checkProperty( this.value ,'completedActivities' ,'length') >0 && this.value['completedActivities'].indexOf('SUBMIT_TO_USCIS') >-1 ){
                submitToUscisCompleted =true;
              }
              if( !this.checkUscisIsCompleted && !this.checkProperty(this.jobDetails ,'jobTitle') && !submitToUscisCompleted  ){
                this.editJobDetails =true;
              }
          }
        }, 0);

      },
      updatesocCode(item){ 

      if(_.has( item ,'id')){
        this['jobDetails']['socCode'] = item['id'];
      }else{
        this['jobDetails']['socCode'] = '';
      }
      },
      getMasterSocList(){

      let query = {};
      query["page"] = 1;
      query["perpage"] = 10000;
      query["matcher"] = { 
         "getInactiveListAlso": true
        };
      query["category"] = "soc_codes";


      this.$store
      .dispatch("getMasterData", query)
      .then((response) => {
        this.masterSocList = response.list;



      //alert(this.perpage);
      })
      .catch(() => {
      this.masterSocList = [];

      });

      },
      downloadfile(value) {
      if(_.has(value ,"url" ) && !(_.has(value ,"path" ) )){
        value =Object.assign(value ,{ "path":value['url']})
      }else  if(_.has(value ,"path" ) && !(_.has(value ,"url" )) ){
        value =Object.assign(value ,{ "url":value['path']})
      }
      
      this.$emit('download_or_view' ,value);
      // value.url = value.url.replace(this.$globalgonfig._S3URL,"");
      // value.url = value.url.replace(this.$globalgonfig._S3URLAWS,"");
      // let postdata = { keyName: value.url };
      // this.$store.dispatch("getSignedUrl", postdata).then((response) => {
      //   window.open(response.data.result.data, "_blank");
      // });
    },
        selectDoctype(type = "") {
            this.uploaddocType = type;
        },
        upload(model, uploaddocType) {
      this.is_enablesavebtn = false;
      
      let temp_count = 0;
      this.uploaddocType = uploaddocType;
      let formData = new FormData();
      if (model.length > 0) {
        this.$vs.loading();
        model.forEach((doc) => {
          formData.append("files", doc.file);
          formData.append("secureType", "public");
          this.$store.dispatch("uploadS3File", formData).then((response) => {
           temp_count++;
            let docmnt = {
              mimetype: model[0]["file"]["type"],
              name: model[0]["file"]["name"],
              status: true,
              uploadedOn: new Date(),
              url: response["data"]["result"][0],
              path: response["data"]["result"][0],
              tempDoc:true
            };

            this.petition["documents"][this.uploaddocType].push(docmnt);
            this.is_enablesavebtn = true;
            if (temp_count >= model.length) {
                 
                  this.$vs.loading.close();
              }
          });
        });
      }
    },
    },
    computed:{
      checkUscisIsCompleted(){
        let returnVal =false;
        if(_.has( this.petition ,'completedActivities') && this.petition.completedActivities.indexOf('SUBMIT_TO_USCIS') >= 0){
          returnVal = true;
        }
        return returnVal;
      }
    }
}
</script>